export const REM_SIZE_IN_PX = 16;
